<template>
	<div id="q-app">
		<router-view />

		<activity-downloader />
	</div>
</template>

<script>
import ActivityDownloader from './components/utils/ActivityDownloader'
import { mapGetters } from 'vuex'
import { createMetaMixin } from 'quasar'

const metaData = {
	title: process.env.PROJECT_NAME ?? 'Etraining',
	// optional; sets final title as "Index Page - My Website", useful for multiple level meta
	titleTemplate: (title) => `${process.env.PROJECT_NAME} | ${title}`,

	// meta tags
	meta: {
		description: { name: 'description', content: 'Powered by Take 5' },
		keywords: {
			name: 'keywords',
			content: 'Etraining, e-learning, learning, training, courses, LMS, education, business',
		},
		equiv: { 'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8' },
	},
}

export default {
	name: 'App',

	computed: {
		...mapGetters({
			offline_activities: 'offline_course/activities',
		}),
	},

	components: {
		'activity-downloader': ActivityDownloader,
	},

	mixins: [createMetaMixin(metaData)],

	created() {
		if (this.$q.platform.is.capacitor) {
			let offline_activities_copy = Object.assign([], this.offline_activities)
			if (offline_activities_copy) {
				offline_activities_copy.forEach((activity, index) => {
					if (activity.downloading) offline_activities_copy.splice(index, 1)
				})
			}
			this.$store.dispatch('offline_course/SET_ACTIVITIES', [offline_activities_copy])
		}
	},
}
</script>
